var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Components\n  "),_c('ConectaTable',{attrs:{"configs":_vm.configs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }